import { ApiHandler, HasOnComplete, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetWishListsApiParameter, getWishLists } from "@insite/client-framework/Services/WishListService";
import {
    chain,
    DispatchCompleteLoadWishLists,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { WishListCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<GetWishListsApiParameter & HasOnSuccess & HasOnComplete, WishListCollectionModel>;

export const DispatchCompleteLoadWishListsCustom: HandlerType = props => {
    props.dispatch({
        type: "Data/WishLists/CompleteLoadWishLists",
        result: props.apiResult,
        parameter: props.parameter,
    });

    if (props.apiParameter.onComplete) {
        props.apiParameter?.onComplete(props.apiResult);
    }
};

export const RequestDataFromApiNew: HandlerType = async props => {
    props.apiParameter.pageSize = props.apiParameter.filter == "HomePage"? 2 : 999;
    props.apiResult = await getWishLists({ pageSize: props.apiParameter.pageSize});
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiNew);

replaceInChain(chain, DispatchCompleteLoadWishLists, DispatchCompleteLoadWishListsCustom);
